module.exports = global["React"] = require("-!./react.js");


//////////////////
// WEBPACK FOOTER
// ./~/react/react.js
// module id = 132
// module chunks = 0